import { useState, useRef, useEffect, useCallback } from 'react';

const TYPING_SPEED = 150;

export function useTypewriter(
    text: string,
    onTextChanged: (newText: string) => void,
    enabled: boolean,
) {
    const [isTyping, setIsTyping] = useState(false);
    const textRef = useRef(text);
    const wordIndexRef = useRef(0);

    const setIsTypingEnabled = useCallback(
        (isEnabled: boolean) => {
            setIsTyping(enabled && isEnabled);
        },
        [setIsTyping, enabled],
    );

    useEffect(() => {
        textRef.current = text;
        setIsTypingEnabled(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text.length]);

    useEffect(() => {
        if (!isTyping) return;
        let timer: NodeJS.Timeout | undefined = undefined;
        const typeNextWord = () => {
            const words = textRef.current.split(' ');
            onTextChanged(words.slice(0, wordIndexRef.current + 1).join(' '));
            wordIndexRef.current++;

            if (wordIndexRef.current >= words.length) {
                setIsTypingEnabled(false);
            } else {
                timer = setTimeout(typeNextWord, TYPING_SPEED);
            }
        };

        typeNextWord();
        return () => {
            clearTimeout(timer);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTyping]);

    useEffect(() => {
        setIsTypingEnabled(enabled);
        if (!enabled) {
            onTextChanged(text);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled]);
}
